(function () {
  'use strict';
  var page = document.querySelector('.smg-page--concept2');
  if (!page) return;
  var toggle = page.querySelector('[data-smg-menu-toggle]');
  var nav = page.querySelector('[data-smg-nav]');
  var header = page.querySelector('[data-smg-header]');
  function closeMenu() {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Menu openen');
    nav.classList.remove('smg-is-open');
    document.body.classList.remove('smg-menu-open');
  }
  toggle.addEventListener('click', function () {
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    if (!open) return closeMenu();
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Menu sluiten');
    nav.classList.add('smg-is-open');
    document.body.classList.add('smg-menu-open');
  });
  page.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      closeMenu(); toggle.focus();
    }
  });
  nav.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', closeMenu); });
  function resize() {
    page.style.setProperty('--header-offset', (header.offsetHeight + 16) + 'px');
    if (window.innerWidth > 800) closeMenu();
  }
  window.addEventListener('resize', resize);
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(header);
  resize();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var slides = page.querySelectorAll('[data-smg-hero-slide]');
  var pause = page.querySelector('[data-smg-slider-toggle]');
  var current = 0, timer, paused = reduced.matches;
  function start() {
    window.clearInterval(timer);
    if (pause) {
    pause.textContent = paused ? 'Afspelen' : 'Pauze';
    pause.setAttribute('aria-label', paused ? 'Fotowisseling starten' : 'Fotowisseling pauzeren');
    pause.setAttribute('aria-pressed', String(paused));
    }
    if (paused || document.hidden || slides.length < 2) return;
    timer = window.setInterval(function () {
      slides[current].classList.remove('smg-is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = (current + 1) % slides.length;
      slides[current].classList.add('smg-is-active');
      slides[current].setAttribute('aria-hidden', 'false');
    }, 6000);
  }
  if (pause) {
    pause.addEventListener('click', function () { paused = !paused; start(); });
  }
  if (slides.length > 1) {
    document.addEventListener('visibilitychange', start);
    reduced.addEventListener('change', function () { paused = reduced.matches; start(); });
    start();
  }

  var accessForm = page.querySelector('#B2BAccessForm');
  if (accessForm) {
    var endpoint = 'https://sophie-me-b2b-kvk.webshop-518.workers.dev/api/kvk/approve';
    var submitButton = accessForm.querySelector('button[type="submit"]');
    var statusMessage = document.createElement('div');
    statusMessage.className = 'smg-form__errors';
    statusMessage.setAttribute('role', 'status');
    statusMessage.setAttribute('aria-live', 'polite');
    statusMessage.hidden = true;
    submitButton.parentNode.insertBefore(statusMessage, submitButton);

    function field(name) {
      return accessForm.querySelector('[name="' + name + '"]');
    }

    function value(name) {
      var input = field(name);
      return input ? input.value.trim() : '';
    }

    function showStatus(message, success) {
      statusMessage.className = success ? 'smg-form__success' : 'smg-form__errors';
      statusMessage.innerHTML = '';
      var text = document.createElement('p');
      text.textContent = message;
      statusMessage.appendChild(text);
      statusMessage.hidden = false;
      statusMessage.setAttribute('tabindex', '-1');
      statusMessage.focus();
    }

    function errorMessage(code) {
      var messages = {
        invalid_kvk_number: 'Vul een geldig KVK-nummer van 8 cijfers in.',
        kvk_not_found: 'Dit KVK-nummer is niet gevonden. Controleer het nummer en probeer opnieuw.',
        inactive_registration: 'Deze KVK-inschrijving is niet actief. Neem contact met ons op als dit niet klopt.',
        invalid_email: 'Vul een geldig e-mailadres in.',
        missing_fields: 'Vul alle verplichte velden volledig in.',
        rate_limited: 'Er zijn te veel pogingen gedaan. Wacht tien minuten en probeer het daarna opnieuw.'
      };
      return messages[code] || 'De aanvraag kon nu niet worden gecontroleerd. Probeer het later opnieuw of mail naar webshop@sophie-me.nl.';
    }

    accessForm.addEventListener('submit', function (event) {
      event.preventDefault();
      statusMessage.hidden = true;
      if (!accessForm.reportValidity()) return;

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = 'KVK controleren…';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          company: value('contact[Bedrijfsnaam]'),
          contactName: value('contact[name]'),
          city: value('contact[Vestigingsplaats]'),
          phone: value('contact[phone]'),
          email: value('contact[email]'),
          kvkNumber: value('contact[KvK-nummer]'),
          website: ''
        })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.body.ok) {
            throw new Error(result.body.error || 'request_failed');
          }

          accessForm.querySelectorAll('input, button').forEach(function (element) {
            element.disabled = true;
          });
          showStatus('Je KVK-inschrijving is gecontroleerd en je zakelijke account is goedgekeurd voor ' + result.body.companyName + '.', true);

          var loginLink = document.createElement('a');
          loginLink.className = 'smg-button smg-button--dark';
          loginLink.href = 'https://shopify.com/6677561399/account';
          loginLink.textContent = 'Inloggen met e-mailcode →';
          statusMessage.appendChild(loginLink);
        })
        .catch(function (error) {
          showStatus(errorMessage(error.message), false);
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          submitButton.innerHTML = 'Toegang aanvragen <span aria-hidden="true">→</span>';
        });
    });
  }

})();
